import { apiClient } from "@/lib/api/client";
import { apiPaths } from "@/lib/api/paths";
import type { ExportIndividualsResponse } from "./type";
import { isEmpty } from "@utils/formatters";
import type { IndividualsFilters } from "@typings/entities/individuals/table";

export async function exportIndividuals(
  query?: IndividualsFilters,
): Promise<ExportIndividualsResponse> {
  const params = new URLSearchParams();

  if (query) {
    Object.entries(query).forEach(([key, value]) => {
      if (isEmpty(value)) return;

      params.append(key, String(value));
    });
  }

  let url = apiPaths.individuals.export;
  if (params.toString()) {
    url += `?${params.toString()}`;
  }

  const response = await apiClient.get<ExportIndividualsResponse>(url);

  return response.data;
}
